import { combineReducers } from 'redux';
import auth from './authReducer';
import user from './userReducer';
import permissions from './permissionReducer';
import roles from './roleReducer';
import transportationModes from './transportationModesReducer';
import applications from './applicationReducer';

const allReducers = combineReducers({
  auth,
  permissions,
  roles,
  user,
  transportationModes,
  applications,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_APP') {
    state = undefined;
  }
  return allReducers(state, action);
};

const exportedRoot = (state: any, action: { [key: string]: any }) => {
  return rootReducer(action.type === 'RESET_APP_SUCCESS' ? { auth: { loggedIn: false } } : { ...state, ...auth }, action);
};

export default exportedRoot;
